module.exports = __webpack_public_path__ + "static/img/main-bg.117523cb.png";